import React, { Fragment } from "react";
import classes from './Redundancy.module.css'
import { useNavigate } from "react-router-dom";
import ResultsTable from "../components/simple_view/ResultsTableRedundancy";

const SimpleResults = (props) => {


  let navigate = useNavigate();

  return (
    <Fragment>
     
          <ResultsTable></ResultsTable>

    </Fragment>
  );
};

export default SimpleResults